<template>
    <button :class="['card', role]" :disabled="disabled" @click="onClickCard">
        <div class="card-title-wrap">
            <div class="card-title">{{ role }}</div>
            <div class="card-desc">
                <h3>{{ title }}</h3>
                <div v-html="desc"></div>
            </div>
            <div v-if="role === 'R2 Planner'" class="coming-soon">Coming Soon</div>
        </div>
        <div class="image-wrap">
            <img :src="imageSrc" :class="role" />
        </div>
    </button>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from "vue-router"

import playerImg from '@/assets/playground/img/signup/signup-r2-player.png';
import centerImg from '@/assets/playground/img/signup/signup-r2-center.png';
import plannerImg from '@/assets/playground/img/signup/signup-r2-planner.png';
import crewImg from '@/assets/playground/img/signup/signup-r2-crew.png';

export default {
    name: "RoleCard",
    props: {
        role: String,
        title: String,
        desc: String,
        disabled: {
            type: Boolean, default: false, required: false
        }
    },
    setup (props) {
        const router = useRouter();
        const roleMap = {
        "R2 Player": "players",
        "R2 Center": "centers",
        "R2 Planner": "planners",
        "R2 Center Crew": "Crews"
        };

        const imageMap = {
            'R2 Player': playerImg,
            'R2 Center': centerImg,
            'R2 Planner': plannerImg,
            'R2 Center Crew': crewImg
        };

        const imageSrc = computed(() => {
            return imageMap[props.role];
        })
        const isDisabledRole = computed(() => {
            return props.disabled || props.role === 'R2 Planner';
        });

        const onClickCard = () => {
            if (isDisabledRole.value) {
                return;
            }

            router.push(`join/agreement/${roleMap[props.role]}`);
        };

        return {
            onClickCard,      
            imageSrc
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    all: unset;
    cursor: pointer;
    border-radius: 20px;
    border: 1px solid #d9d9d9;
    height: 672px;
    background: #ffffff;
    box-shadow: 3px 4px 50px rgba(91,75,232, 0.35);
    padding: 48px 12px 12px 30px;
    width: 410px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &.R2.Player {
        &:hover {
            background: rgba(140, 132, 235, 0.7);
        }
        &:active {
            background: rgba(140, 132, 235, 0.5);
        }
    }
    &.R2.Center {
        &:hover {
           background: #ABBDFD;
        }
        &:active {
            background: rgba(171, 189, 253, 0.5);
        }
    }
    &.R2.Planner {
        cursor: auto;
        // &:hover {
        //    background: #F2B1F3;
        // }
        // &:active {
        //     background: rgba(242, 177, 243, 0.5);
        // }
    }
    &.R2.Center.Crew {
        &:hover {
            background: #ABBDFD;
        }
        &:active {
            background: rgba(171, 189, 253, 0.5);
        }
    }
    &:disabled {
        opacity: 0.3;
        cursor: auto;
        pointer-events: none;
    }
}
.card-title-wrap {
    display: flex;
    flex-direction: column;
}
.card-title {
    font-weight: 700;
    font-size: 50px;
    line-height: 60px;
    margin-bottom: 5px;
}
.card-desc {
    display: flex;
    flex-direction: column;
    gap: 25px;
    font-size: 20px;
    line-height: 130%;
    font-weight: 200;
    > h3 {
        font-size: 20px;
        font-weight: 600;
    }
}
.image-wrap {
    display: flex;
    justify-content: end;
    > img .R2.Player {
        width: 302.96px;
        height: 306.71px;
    }
}
.coming-soon {
    font-weight: 800;
    font-size: 50px;
    padding-left: 17px;
    line-height: 130%;
    margin-top: 40px;
}
</style>